import React, { Component } from "react";
import MainPage from "./MainPage";
import api from "../utility/api/api.js";
import { connect } from "react-redux";
import { actionProcessingJobs, actionIntransitJob } from "../actions/index";
import { bindActionCreators } from "redux";
class HomePage extends Component {
  componentWillMount() {
    api.callAssignedJobs(this, "in-transit");
  }
  render() {
    return (
      <div>
        <MainPage />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    jobs: state.processingJobs,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionProcessingJobs: actionProcessingJobs,
      actionIntransitJob: actionIntransitJob,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage.js